import { render, staticRenderFns } from "./XmSaleableArea.vue?vue&type=template&id=e70b856a&scoped=true"
import script from "./XmSaleableArea.vue?vue&type=script&lang=js"
export * from "./XmSaleableArea.vue?vue&type=script&lang=js"
import style0 from "./XmSaleableArea.vue?vue&type=style&index=0&id=e70b856a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70b856a",
  null
  
)

export default component.exports